module.exports = __webpack_public_path__ + "img/violet_126.f03b5b11.png";